import './index.scss'
import {isGutenbergEditorVisible} from "../../src/scripts/helpers";

function init(scope = document) {
    const nodeSelectors = {
        container: '[js-hero="container"]',
        sliderContainer: '[js-hero="slider-container"]',
        slider: '[js-hero="slider"]',
        sliderPrev: '[js-hero="slider-prev"]',
        sliderNext: '[js-hero="slider-next"]',
    }

    const containers = scope.querySelectorAll(nodeSelectors.container)

    if (!containers.length) return

    containers.forEach((container) => {
        const sliderContainer = container.querySelector(nodeSelectors.sliderContainer);

        if( !sliderContainer ) return

        const sliderEl = sliderContainer.querySelector(nodeSelectors.slider);

        // Slider
        if( sliderContainer && sliderEl ) {
            // Destroy existing swiper instance before re-init
            if (sliderEl.swiper) {
                sliderEl.swiper.destroy(true, true);
            }

            const settings = {
                slidesPerView: 1,
                spaceBetween: 20,
                loop: true,
                speed: 600,
                navigation: {
                    nextEl: container.querySelector(nodeSelectors.sliderNext),
                    prevEl: container.querySelector(nodeSelectors.sliderPrev),
                },
                effect: "fade",
                fadeEffect: {
                    crossFade: true,
                },
                allowTouchMove: false,
                // pagination: {
                //     el: container.querySelector(nodeSelectors.pagination),
                //     clickable: true,
                // },
            };

            new Swiper(sliderEl, settings);
        }
    })
}

document.addEventListener('DOMContentLoaded', () => {
    if ( window.acf ) {
        // Only in block editor preview
        window.acf.addAction('render_block_preview/type=hero', ($block) => {
            const blockEl = $block[0] || $block;
            init(blockEl);
        });
    } else if( !isGutenbergEditorVisible() ) {
        // Only in frontend
        init()
    }
});